import RoutesMap from "../route_control/RouteControl"
import { toast } from "react-toastify"
import SessionManager from "./sessionManager"
import showAccessDeniedAlert from "./accessDenied"

const addUpdateHandler = (data) => {

    const { res, action, navigate, success_toast, wrong_toast, navigate_route, spinner } = data;

    if (res?.status === 201) {
        toast.success(success_toast, { position: "bottom-right" });
        spinner(false);
        setTimeout(() => {
            navigate(navigate_route);
        }, 1500);
    } else if (res?.status === 200) {
        toast.success(success_toast, { position: "bottom-right" });
        spinner(false);
        setTimeout(() => {
            navigate(navigate_route);
        }, 1500);
    } else if (res?.status === 401) {
        SessionManager.removeCookie("user_token");
        navigate(RoutesMap.LOGIN.path);
    } else if (res?.status === 400) {
        toast.error(res?.data?.message, { position: "bottom-right", closeOnClick: true });
        spinner(false);
    } else if (res?.status === 403) {
        showAccessDeniedAlert(navigate)
        spinner(false);
    } else {
        toast.error(wrong_toast, { position: "bottom-right", closeOnClick: true });
        spinner(false);

    }
};

export default addUpdateHandler;